import type { LinkInBioPaths } from '@repo/lib';
import { appUrl, isPreview, isStaging, rootDomain, storeUrl } from './env';
import getSellerDomain from './getSellerDomain';
import getStorePreviewOrigin from './getStorePreviewOrigin';

type SellerUrlFields = {
  name?: string | null;
  customDomain?: string | null;
  customDomainVerified?: boolean;
  homepage?: { type?: string | null } | null;
};

// The marketing site serves /@ and /c/ from the store. Instance stacks and Vercel
// previews run without the site, so only the store's own /c/ route works there.
function siteOrigin(): string | null {
  if (storeUrl || (isPreview && !isStaging)) return null;
  return isStaging ? `https://${rootDomain}` : String(appUrl);
}

const baseUrl = () =>
  String(siteOrigin() ?? storeUrl ?? getStorePreviewOrigin()).replace(/\/$/, '');

export function getLinkInBioUrl(seller: SellerUrlFields): string | null {
  return seller?.name ? `${baseUrl()}/c/${seller.name}` : null;
}

export function getLinkInBioShortUrl(seller: SellerUrlFields): string | null {
  const site = siteOrigin();
  if (!seller?.name) return null;
  return site ? `${site.replace(/\/$/, '')}/@${seller.name}` : getLinkInBioUrl(seller);
}

export function getLinkInBioHomepageUrl(seller: SellerUrlFields): string {
  return getSellerDomain(seller);
}

export function getLinkInBioSharedUrl(seller: SellerUrlFields): string | null {
  const shortUrl = getLinkInBioShortUrl(seller);
  if (!shortUrl) return null;
  return seller.homepage?.type === 'linkInBio' ? getLinkInBioHomepageUrl(seller) : shortUrl;
}

export function getLinkInBioPreviewPaths(seller: SellerUrlFields): LinkInBioPaths {
  const name = seller?.name ?? '';
  return { pagePrefix: `${baseUrl()}/c/${name}/`, portal: `${baseUrl()}/s/${name}/portal` };
}

export function withLinkInBioQuery(url: string, query: Record<string, string>): string {
  const [base, hash] = url.split('#');
  const separator = base.includes('?') ? '&' : '?';
  const search = new URLSearchParams(query).toString();
  return `${base}${separator}${search}${hash ? `#${hash}` : ''}`;
}

export const LINK_IN_BIO_SELLER_VISIT = { cp_preview: '1' };
